// State
const state = () => ({
    currentStep: '',
})

// Getter Types
export const uploadProgressGetterTypes = {
    CURRENT_STEP: 'uploadProgress/currentStep',
    PROGRESS: 'uploadProgress/progress',
    STATUS_MESSAGE: 'uploadProgress/statusMessage',
    IS_ACTIVE: 'uploadProgress/isActive',
}

// Mutation Types
export const uploadProgressMutationTypes = {
    SET_CURRENT_STEP: 'uploadProgress/setCurrentStep',
}

// Action Types
export const uploadProgressActionTypes = {
    UPDATE_STEP: 'uploadProgress/updateStep',
}

// Progress Mappingwhy
export const UploadProgressSteps = Object.freeze({
    START_UPLOADING: { step: 'Start uploading', progress: 10 },
    CONNECTING_TO_MEDIA_SERVICE: {
        step: 'Connecting to Media Service',
        progress: 20,
    },
    SENDING_FILES_TO_MEDIA_SERVICE: {
        step: 'Sending files to Media Service',
        progress: 40,
    },
    DECODING_FILE: { step: 'Decoding file', progress: 60 },
    GENERATING_PREVIEW_IMAGE: {
        step: 'Generating preview image for',
        progress: 70,
    },
    UPLOADING_FILE_TO_AWS: { step: 'Uploading files to AWS', progress: 90 },
    UPLOADING_COMPLETE: { step: 'Upload complete', progress: 100 },
    UPLOAD_FAILED: { step: 'Upload failed', progress: 100 },
})

// Getters
const getters = {
    [uploadProgressGetterTypes.CURRENT_STEP](state) {
        return state.currentStep
    },
    [uploadProgressGetterTypes.PROGRESS](state) {
        return UploadProgressSteps[state.currentStep]?.progress || 0
    },
    [uploadProgressGetterTypes.STATUS_MESSAGE](state) {
        return UploadProgressSteps[state.currentStep]?.step || 'Initializing...'
    },
    [uploadProgressGetterTypes.IS_ACTIVE](state) {
        return state.currentStep !== ''
    },
}

// Mutations
const mutations = {
    [uploadProgressMutationTypes.SET_CURRENT_STEP](state, step) {
        state.currentStep = step
    },
}

// Actions
const actions = {
    [uploadProgressActionTypes.UPDATE_STEP]({ commit, state }, step) {
        if (step === 'UPLOADING_COMPLETE') {
            setTimeout(() => {
                commit(uploadProgressMutationTypes.SET_CURRENT_STEP, '')
            }, 250)
        }

        if (step === 'UPLOAD_FAILED') {
            setTimeout(() => {
                commit(uploadProgressMutationTypes.SET_CURRENT_STEP, '')
            }, 250)
        }

        commit(uploadProgressMutationTypes.SET_CURRENT_STEP, step)
    },
}

// Export the module
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
